export interface Account {
  id: number;
  name: string;
  balance: number;
  currency: string;
}

export interface Transaction {
  id: number;
  date: string;
  description: string;
  amount: number;
  type: 'credit' | 'debit';
  status: 'completed' | 'pending' | 'failed';
}

export interface DashboardStats {
  totalBalance: number;
  recentTransactions: number;
  activeAccounts: number;
  pendingApprovals: number;
}

const accounts: Account[] = [
  { id: 1, name: 'Main Account', balance: 1000000, currency: 'USD' },
  { id: 2, name: 'Savings Account', balance: 234567, currency: 'USD' },
  { id: 3, name: 'Investment Account', balance: 500000, currency: 'USD' },
];

const transactions: Transaction[] = [
  { id: 1, date: '2023-05-01', description: 'Salary Deposit', amount: 5000, type: 'credit', status: 'completed' },
  { id: 2, date: '2023-05-02', description: 'Rent Payment', amount: 2000, type: 'debit', status: 'completed' },
  { id: 3, date: '2023-05-03', description: 'Utility Bill', amount: 150, type: 'debit', status: 'pending' },
  { id: 4, date: '2023-05-04', description: 'Stock Investment', amount: 1000, type: 'debit', status: 'completed' },
];

const dashboardStats: DashboardStats = {
  totalBalance: 1734567,
  recentTransactions: 24,
  activeAccounts: 8,
  pendingApprovals: 3,
};

export const getAccounts = (): Account[] => {
  return accounts;
};

export const getTransactions = (): Transaction[] => {
  return transactions;
};

export const getDashboardStats = (): DashboardStats => {
  return dashboardStats;
}; 